export const frontmatter = {
    title: "Documentación de OnnIA",
    description: "Guías, referencias y recursos para construir y operar con la plataforma OnnIA.",
    sidebar_label: "Inicio",
    sidebar_order: 0,
    toc: false,
}

export const toc = []